import {
  Button,
  Card,
  CardContent,
  CardHeader,
  colors,
  Divider,
  Grid,
  Link,
  Switch,
  Tab,
  Tabs,
  TextField,
  Theme,
  Typography
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {useSnackbar} from 'notistack';
import React, {useEffect, useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import useRouter from 'use-react-router';
import useReactRouter from 'use-react-router';
import validate from 'validate.js';
import {Can} from '../../../components/Can';
import ConfirmDelete from '../../../components/ConfirmDelete';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import {InternationalPhoneInput} from '../../../components/PhoneInput/PhoneInput';
import {OPERATOR} from '../../../graphql/common.datatypes';
import {
    GroupMember,
    GroupMemberRoleType,
    GroupMemberRoleTypes, RoomPartyMember,
    TourRoleType,
    TourRoleTypes
} from '../../../graphql/groups.datatypes';
import anyLoading from '../../../utils/anyLoading';
import {getHandleFieldChange, getHasError} from '../../../utils/formHelpers';
import getAllGroups from './getAllGroups.api';
import getGroupMember from '../getGroupMember.api';
import createGroupMember, {CreateGroupMemberInput} from './createGroupMember.api';
import deleteGroupMember from './deleteGroupMember.api';
import updateGroupMember, {UpdateGroupMemberInput} from './updateGroupMember.api';
import getGroup from '../getGroup.api';
import {RoomPartyMemberOptionsEdit} from '../../RoomParty/RoomPartyMemberOptionsEdit';
import {WcvType} from '../../../graphql/logs.datatypes';
import AddNote from '../../Logs/AddNote/AddNote';
import {red} from '@material-ui/core/colors';
import clsx from 'clsx';
import {GroupMemberAdjustmentsListContent} from '../GroupMemberAdjustmentsList/GroupMemberAdjustmentsList';
import {LogListContent} from '../../Logs/LogList/LogList';
import {WCVDatePicker} from '../../../components/DateUtilsProvider/WCVDatePicker';
import {formatGraphQlDate, formatMoney} from '../../../utils/formatters';
import {DocumentDownloadListContent} from '../../Documents/DocumentsDownloadList/DocumentsDownloadList';
import {getHost} from '../../../graphql/GraphQlProvider';
import ConfirmModal from '../../../components/ConfirmModal';
import authoriseGroupMembersInBillingParty from './authoriseGroupMembersInBillingParty.api';
import cancelGroupMembersInBillingParty from './cancelGroupMembersInBillingParty.api';
import getGroupMemberInMyGroup from '../getGroupMemberInMyGroup.api';
import {checkIsAdmin} from '../../../utils/checkIsAdmin';
import {checkEditLevel} from '../../../utils/checkEditLevel';
import limitedUpdateGroupMember from './limitedUpdateGroupMember.api';
import {checkPermission} from '../../../components/Can/Can';
import moment from 'moment';
import {GroupMemberPaymentsList} from '../GroupMemberPaymentsList';
import {checkRoomAvailable} from "../../Resources/AvailableHotelModal/AvailableHotelModal";
import getRoomParty from "../../RoomParty/getRoomParty.api";
import {Resource} from "../../../graphql/resources.datatypes";
import getGroupTourRoles from "../getGroupTourRoles.api";
import { NotesList } from '../../Notes';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  container: {
    marginTop: theme.spacing(3),
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  card: {},
  saveButton: {
    marginLeft: theme.spacing(1),
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  deleteButton: {
    marginLeft: theme.spacing(1),
    color: theme.palette.white,
    backgroundColor: theme.palette.error.light,
    '&:hover': {
      backgroundColor: theme.palette.error.main
    }
  },
  cloneButton: {
    marginLeft: theme.spacing(1),
    color: theme.palette.white,
    backgroundColor: colors.green[400],
    '&:hover': {
      backgroundColor: colors.green[700]
    }
  },
  linkButton: {
    marginRight: theme.spacing(1),
  },
  tabs: {
    marginTop: theme.spacing(3)
  },
  cancelled: {
    backgroundColor: red[100],
  },
}));

// export interface FilterValues {
// }

const getBlankGroupMember = (groupId: number = -1): GroupMember => {
  return {
    __typename: 'GroupMember',
    id: -1,
    group_id: groupId,
    first_name: '',
    last_name: '',
    group_role: GroupMemberRoleType.MEMBER,
    tour_role: TourRoleType.TOUR_ROLE_FAMILY_AND_FRIENDS,
    email: '',
    dob: undefined,
    cellphone_code: '+1',
    validated: false,
    cancelled: false,
    disabled: false,
    authorised: false,
  };
};

const GroupMemberDetailsContent = (props: { groupMember: GroupMember, isAdmin: boolean, canEdit: boolean, groupRef?: string }) => {
  const classes = useStyles();
  const {groupMember, isAdmin, canEdit, groupRef} = props;
  const groupData = getGroupTourRoles(groupMember.group_id!);
  const isNewGroupMember = groupMember.id === -1;
  const {history} = useRouter();
  const {enqueueSnackbar} = useSnackbar();
  const canFullUpdate = checkPermission('groups.update');
  const [sendCreateGroupMember, createData] = createGroupMember();
  const [sendFullUpdateGroupMember, updateData] = updateGroupMember();
  const [sendLimitedUpdateGroupMember, limitedUpdateData] = limitedUpdateGroupMember();
  const sendUpdateGroupMember: any = canFullUpdate ? sendFullUpdateGroupMember : sendLimitedUpdateGroupMember;
  const [sendDeleteGroupMember, deleteData] = deleteGroupMember();

  const [sendAuthAllGroupMembers, authoriseData] = authoriseGroupMembersInBillingParty();
  const [sendCancelAllGroupMembers, cancelData] = cancelGroupMembersInBillingParty();

  const [tab, setTab] = useState('details');
  const [openModal, setOpenModal] = useState(false);

  const allGroupsData = getAllGroups({
    AND: [
      {column: 'disabled', operator: OPERATOR.EQ, value: `false`},
      {column: 'locked', operator: OPERATOR.EQ, value: `false`},
    ]
  });
    // @ts-ignore
    const room_party_id:number = groupMember && groupMember.roomMember && groupMember.roomMember.room_party_id;
    // const room_party_id = groupMember && groupMember.roomMember && groupMember.roomMember.room_party_id;
    const roomPartyData = getRoomParty(room_party_id, true);

  //1. Set form and error state
  const [formState, setFormState] = useState({
    ...groupMember,
    cellphone_code: groupMember.cellphone_code ? groupMember.cellphone_code : '+1',
    cellphone: groupMember.cellphone ? groupMember.cellphone : '',
    email: groupMember.email ? groupMember.email : '',
  });
  const loadingData = anyLoading(createData, updateData, deleteData, groupData, authoriseData, cancelData, limitedUpdateData);
  const [errors, setErrors] = useState({
    isValid: false,
    errors: {
      title: false,
      first_name: false,
      last_name: false,
      group_id: false,
    }
  });

  useEffect(() => {
    setFormState({
      ...groupMember,
      cellphone_code: groupMember.cellphone_code ? groupMember.cellphone_code : '+1',
      cellphone: groupMember.cellphone ? groupMember.cellphone : '',
      email: groupMember.email ? groupMember.email : '',
    });
  }, [groupMember]);

  //2. Setup helper functions for form
  const handleFieldChange = getHandleFieldChange(setFormState);
  const hasError = getHasError(errors);

  //3. setup validation and error hook
  const validateSchema: any = {
    first_name: {
      presence: {allowEmpty: false, message: 'is required'},
    },
    last_name: {
      presence: {allowEmpty: false, message: 'is required'},
    },
    dob: {
      presence: {allowEmpty: false, message: 'is required'},
    },
    group_id: {
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        message: 'is required'
      }
    },
  };

  useEffect(() => {
    if (formState.authorised && formState.authorised !== props.groupMember.authorised) {
      handleOpenAuthoriseAllModal();
    } else {
      setAuthorizeAllInGroup(false);
    }
  }, [formState.authorised]);

  useEffect(() => {
    if (formState.cancelled && formState.cancelled !== props.groupMember.cancelled) {
      handleOpenCancelAllModal();
    } else {
      setCancelAllInGroup(false);
    }
  }, [formState.cancelled]);

  useEffect(() => {
    const newErrors = validate(formState, validateSchema);

    setErrors(state => ({
      ...state,
      isValid: !newErrors,
      errors: newErrors || {}
    }));
  }, [formState]);

  //4. Handle save form
  const onSaveClick = () => {
      if (groupMember.cancelled && !formState.cancelled) {
          // @ts-ignore
          const start: string = groupMember && groupMember.roomMember && groupMember.roomMember.start_date!;
          // @ts-ignore
          const end: string = groupMember && groupMember.roomMember && groupMember.roomMember.end_date!;
          // @ts-ignore`
          const hotel: Resource = roomPartyData && roomPartyData.data && roomPartyData.data.roomParty && roomPartyData.data.roomParty.hotel!;
          // @ts-ignore`
          const members: number = roomPartyData.data && roomPartyData.data.roomParty && roomPartyData.data.roomParty.members!.length;

          const roomAvailable = checkRoomAvailable(
              hotel,
              moment(new Date(start)),
              moment(new Date(end)),
              members
          );
          if (!roomAvailable) {
              enqueueSnackbar('No Rooms Available', {variant: 'error'});
              return false;
          }
      }
    if (isNewGroupMember) {
      const sanitisedData: CreateGroupMemberInput = {
        data: {
          ...{
            ...formState,
            id: undefined,
            __typename: undefined,
            group: undefined,
            user: undefined,
            ageAtEvent: undefined,
            options: undefined,
            roomMember: undefined,
            groupMemberPayments: undefined,
            adjustments: undefined,
            dob: formatGraphQlDate(formState.dob),//formState.dob ? moment(formState.dob).format('YYYY-MM-DD') : undefined,
          },
        }
      };

      sendCreateGroupMember({variables: sanitisedData})
        .then((response) => {
          enqueueSnackbar('Group Member Saved.', {variant: 'success'});
          history.push('/groups/' + response.data!.createGroupMember.group_id);
        })
        .catch(() => {
          enqueueSnackbar('Save Group Member Failed!', {variant: 'error'});
        });
    } else {
      const sanitisedData: UpdateGroupMemberInput = {
        data: {
          ...{
            ...formState,
            __typename: undefined,
            group: undefined,
            user: undefined,
            ageAtEvent: undefined,
            options: undefined,
            roomMember: undefined,
            adjustments: undefined,
            documents: undefined,
            groupMemberPayments: undefined,
            dob: formatGraphQlDate(formState.dob),//formState.dob ? moment(formState.dob).format('YYYY-MM-DD') : undefined,
          },
        }
      };

      sendUpdateGroupMember({variables: sanitisedData})
          .then((response: any) => {
              const {data: {cancelled}} = sanitisedData
              const {data: {updateGroupMember: {roomMember: {options}}}} = response;
              const deletedOptions = options.filter((option: any) => option.deleted_at !== null)
              if (!cancelled && deletedOptions.length > 0){
                  handleOpenUnavailableOptionsModal()
              }
            enqueueSnackbar('Group Member Updated.', {variant: 'success'});
            if (authorizeAllInGroup) {
              const responsGroupMember = canFullUpdate ? response.data!.updateGroupMember! : response.data!.limitedUpdateGroupMember!;
              if (responsGroupMember.roomMember) {
                sendAuthAllGroupMembers({
                  variables: {
                    id: responsGroupMember.roomMember.billing_party_id!,
                    authorise: true
                  }
                })
                    .then(() => {
                      enqueueSnackbar('Authorise all Group Members Success.', {variant: 'success'});
                    })
                    .catch(() => {
                      enqueueSnackbar('Authorise all Group Members Failed!', {variant: 'error'});
                    });
              }
            }
            if (cancelAllInGroup) {
              const responsGroupMember = canFullUpdate ? response.data!.updateGroupMember! : response.data!.limitedUpdateGroupMember!;
              if (responsGroupMember.roomMember) {
                sendCancelAllGroupMembers({
                  variables: {
                    id: responsGroupMember.roomMember.billing_party_id!,
                    cancel: true
                  }
                })
                    .then(() => {
                      enqueueSnackbar('Cancel all Group Members Success.', {variant: 'success'});
                    })
                    .catch(() => {
                      enqueueSnackbar('Cancel all Group Members Failed!', {variant: 'error'});
                    });
              }
            }
          })
          .catch(() => {
            enqueueSnackbar('Group Member Update Failed!', {variant: 'error'});
          });
    }
  };

  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const handleOpenDeleteModal = () => setOpenDeleteModal(true);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  const handleDelete = () => {
    sendDeleteGroupMember({variables: {id: formState.id}})
        .then(() => {
          enqueueSnackbar('Group Member Deleted.', {variant: 'success'});
          history.goBack();
        })
        .catch(() => {
          enqueueSnackbar('Deleted Group Member Failed!', {variant: 'error'});
        });

    handleCloseDeleteModal();
  };

  const [authorizeAllInGroup, setAuthorizeAllInGroup] = React.useState(false);
  const [openAuthoriseAllModal, setOpenAuthoriseAllModal] = React.useState(false);
  const handleOpenAuthoriseAllModal = () => setOpenAuthoriseAllModal(true);
  const handleCloseAuthoriseAllModal = () => setOpenAuthoriseAllModal(false);

  const [cancelAllInGroup, setCancelAllInGroup] = React.useState(false);
  const [openCancelAllModal, setOpenCancelAllModal] = React.useState(false);
  const handleOpenCancelAllModal = () => setOpenCancelAllModal(true);
  const handleCloseCancelAllModal = () => setOpenCancelAllModal(false);

  const [openUnavailableOptionsModal, setOpenUnavailableOptionsModal] = React.useState(false);
  const handleOpenUnavailableOptionsModal = () => setOpenUnavailableOptionsModal(true);
  const handleCloseUnavailableOptionsModal = () => setOpenUnavailableOptionsModal(false);

  const onCloneClick = () => {
    // sendCloneResource({variables: {id: props.resource.id!}})
    //   .then((response) => {
    //     enqueueSnackbar('Resource Cloned.', {variant: 'success'});
    //     const newResource = response.data!.cloneResource as Resource;
    //     if(props.onResourceCreated) {
    //       props.onResourceCreated(newResource);
    //     } else {
    //       history.push('/resources/' + newResource.id);
    //     }
    //   })
    //   .catch(() => {
    //     enqueueSnackbar('Resource Clone Failed!', {variant: 'error'});
    //   });
  };

  const showPrices = isAdmin || (moment(groupMember.group!.end_date).add(15, 'days').diff(moment(), 'days') > 0);

  return (
      <React.Fragment>

        {isAdmin && !isNewGroupMember && (
            <Card className={classes.container}>
              <CardHeader
                  title={'Group Member Totals'}
                  action={[
                    isAdmin && (<Button key={1} variant="contained" className={classes.linkButton}
                                        onClick={() => history.push('/groups/' + props.groupMember.group!.id)}>Go to
                      Group</Button>),
                    !isAdmin && (<Can checkAll={false} permission={['groups.read','associated.groups.read']}><Button key={1} variant="contained"
                                                                                  className={classes.linkButton}
                                                                                  onClick={() => history.push('/mygroups/' + props.groupMember.group!.booking_form_url)}>Go
                      to Group</Button></Can>),
                    isAdmin && groupMember.user && groupMember.user.id && (
                        <Button key={2} variant="contained" className={classes.linkButton}
                                onClick={() => history.push('/users/' + groupMember.user!.id)}>Go To User</Button>),
                    isAdmin && groupMember.roomMember && (
                        <Button key={3} variant="contained" className={classes.linkButton}
                                onClick={() => history.push('/room_party/' + formState.roomMember!.room_party_id)}>Go
                          To Room Party</Button>),
                    !isAdmin && groupMember.roomMember && (
                        <Button key={3} variant="contained" className={classes.linkButton}
                                onClick={() => history.push('/mygroups/room_party/' + btoa(JSON.stringify({
                                  id: formState.roomMember!.room_party_id,
                                  groupRef
                                })))}>Go
                          To Room Party</Button>),
                    isAdmin && groupMember.roomMember && (
                        <Button key={4} variant="contained" className={classes.linkButton}
                                onClick={() => history.push('/billing_party/' + formState.roomMember!.billing_party_id)}>Go
                          To Billing Party</Button>),
                      !isAdmin && groupMember.roomMember && (
                          <Button key={4} variant="contained" className={classes.linkButton}
                                  onClick={() => history.push('/mygroups/billing_party/' + btoa(JSON.stringify({
                                      id: formState.roomMember!.billing_party_id,
                                    groupRef
                                  })))}>Go
                            To Billing Party</Button>),
                    groupMember.documents && groupMember.documents.length > 0 && (<Link key={5}
                                                                                        href={getHost() + '/docs/' + btoa(JSON.stringify({'member': props.groupMember.id}))}>
                      <Button variant="contained">Documents Zip</Button>
                    </Link>),
                  ]}
              />
              <Divider/>
              {showPrices && (
                  <CardContent className={classes.card}>
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item sm={3} xs={12}>
                        <Typography variant="h3">Grand Total:
                          {props.groupMember.roomMember && formatMoney(props.groupMember.roomMember.cost!, true)}</Typography>
                      </Grid>
                      <Grid item sm={3} xs={12}>
                        <Typography variant="h3">Outstanding:
                          {props.groupMember.roomMember && formatMoney(props.groupMember.roomMember.outstandingBalance!,true)}</Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
              )}

              {formState.cancelled && (
                  <CardContent>
                    <Typography color={'error'} variant={'h1'}>CANCELLED</Typography>
                  </CardContent>
              )}
            </Card>
        )}

        <Tabs className={classes.tabs} onChange={(event, value) => setTab(value)} scrollButtons="auto" value={tab}
              variant="scrollable">
          <Tab label="Details" value="details"/>
          {isAdmin && !isNewGroupMember && !formState.cancelled && <Tab label="Options" value="options"/>}
          {isAdmin && !isNewGroupMember && showPrices && <Tab label="Adjustments" value="adjustments"/>}
          {!isNewGroupMember && <Tab label="Documents" value="documents"/>}
          {isAdmin && !isNewGroupMember && <Tab label="Applied Payments" value="payments"/>}
          {/* {isAdmin && !isNewGroupMember && <Tab label="Notes" value="notes"/>} */}
          {isAdmin && !isNewGroupMember && <Tab label="Logs" value="logs"/>}
        </Tabs>

        {tab === 'details' && (
            <LoadingOverlay loading={loadingData.loading}>
              <Card className={clsx({
                [classes.container]: true,
                [classes.cancelled]: formState.cancelled,
              })}>
                <CardHeader title="Group Member Details" action={[
                  // !isNewGroupMember && !groupMember.cancelled && !groupMember.authorised &&
                  // (<Button key={1} variant="contained" className={classes.linkButton} onClick={() => }>Authorize</Button>),
                  // !isNewGroupMember && !groupMember.cancelled && !groupMember.authorised &&
                  // (<Button key={2} variant="contained" className={classes.linkButton} onClick={() => }>Cancel</Button>),
                ]}/>
                <CardContent className={classes.card}>
                  <Grid container spacing={3}>

                    <Grid item md={6} sm={12} xs={12}>
                      <TextField
                          {...hasError('first_name')}
                          fullWidth
                          label="First Name"
                          name="first_name"
                          onChange={handleFieldChange}
                          value={formState.first_name}
                          variant="outlined"
                          disabled={!canEdit || !isAdmin}
                      />
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                      <TextField
                          {...hasError('last_name')}
                          fullWidth
                          label="Last Name"
                          name="last_name"
                          onChange={handleFieldChange}
                          value={formState.last_name}
                          variant="outlined"
                          disabled={!canEdit || !isAdmin}
                      />
                    </Grid>

                    {isAdmin && (
                      <Grid item md={6} sm={12} xs={12}>
                        <InternationalPhoneInput
                            {...hasError('cellphone')}
                            fullWidth
                            notched="true"
                            label="Cellphone"
                            name="cellphone"
                            type="text"
                            value={formState.cellphone}
                            codeValue={formState.cellphone_code}
                            onChange={handleFieldChange}
                            onCodeChange={handleFieldChange}
                            variant="outlined"
                            disabled={!canEdit || !isAdmin}
                        />
                      </Grid>
                    )}

                    {isAdmin && (
                      <Grid item md={6} sm={12} xs={12}>
                        <TextField
                            {...hasError('email')}
                            fullWidth
                            label="Email"
                            name="email"
                            onChange={handleFieldChange}
                            value={formState.email}
                            variant="outlined"
                            disabled={!canEdit}
                        />
                      </Grid>
                    )}

                    {isAdmin && (
                        <Grid item md={4} sm={12} xs={12}>
                          {formState.group && (
                              <TextField
                                  fullWidth
                                  label="Group"
                                  onChange={handleFieldChange}
                                  value={formState.group.name}
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  disabled={true}
                              />
                          )}
                          {!formState.group && allGroupsData.data && allGroupsData.data.allGroups && (
                              <TextField
                                  {...hasError('group_id')}
                                  fullWidth
                                  label="Group"
                                  name="group_id"
                                  onChange={handleFieldChange}
                                  select
                                  // eslint-disable-next-line react/jsx-sort-props
                                  SelectProps={{native: true}}
                                  value={formState.group_id}
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  disabled={!isNewGroupMember || groupMember.group_id !== -1}
                              >
                                <option value={-1}>please select</option>
                                {allGroupsData.data.allGroups.map((group) => (
                                    <option key={group.id} value={group.id}>
                                      {group.name}
                                    </option>
                                ))}
                              </TextField>
                          )}
                        </Grid>
                    )}

                    {isAdmin && (
                      <Grid item md={4} sm={12} xs={12}>
                        {formState.group_role > -1 && (
                            <TextField
                                {...hasError('group_role')}
                                fullWidth
                                label="Group Role"
                                name="group_role"
                                onChange={handleFieldChange}
                                select
                                // eslint-disable-next-line react/jsx-sort-props
                                SelectProps={{native: true}}
                                value={formState.group_role}
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                disabled={!canEdit || !isAdmin}
                            >
                              {GroupMemberRoleTypes.map((type, i) => (
                                  <option key={type.name} value={i}>
                                    {type.name}
                                  </option>
                              ))}
                            </TextField>
                        )}
                      </Grid>
                    )}

                    {isAdmin && (
                      <Grid item md={4} sm={12} xs={12}>
                        {groupData.data && groupData.data.groupTourRoles && groupData.data.groupTourRoles.tour && groupData.data.groupTourRoles.tour!.tour_roles && (
                            <TextField
                                {...hasError('tour_role')}
                                fullWidth
                                label="Tour Role"
                                name="tour_role"
                                onChange={handleFieldChange}
                                select
                                // eslint-disable-next-line react/jsx-sort-props
                                SelectProps={{native: true}}
                                value={formState.tour_role}
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                disabled={!canEdit}
                            >
                              {groupData.data.groupTourRoles.tour.tour_roles.map((type) => (
                                  <option key={type.id} value={type.tour_role}>
                                    {TourRoleTypes[type.tour_role].name}
                                  </option>
                              ))}
                            </TextField>
                        )}
                      </Grid>
                    )}

                    <Grid item  md={8} sm={12} xs={12}>
                      <WCVDatePicker
                          {...hasError('dob')}
                          id="dob"
                          fullWidth
                          label="Date of Birth:"
                          value={formState.dob}
                          onChange={(date, value) => {
                            setFormState({
                              ...formState,
                              dob: value ? value : undefined
                            })
                          }}
                          disabled={!canEdit || !isAdmin}
                      />
                    </Grid>
                    <Grid item  md={4} sm={12} xs={12}>
                      <TextField
                          fullWidth
                          margin="normal"
                          label="Age at Event"
                          value={formState.ageAtEvent}
                          variant="outlined"
                          disabled={true}
                      />
                    </Grid>

                    {isAdmin && (
                        <Grid item md={12} sm={12} xs={12}>
                          <Grid component="label" container alignItems="center" spacing={1}>
                            <Grid item>
                              <Switch
                                  checked={formState.validated}
                                  color="secondary"
                                  edge="start"
                                  name="validated"
                                  onChange={handleFieldChange}
                                  value={formState.validated}
                                  disabled={!canEdit || !isAdmin}
                              />
                            </Grid>
                            <Grid item><Typography variant="h5">Validated?</Typography></Grid>
                          </Grid>
                        </Grid>
                    )}

                    {isAdmin && (
                        <Grid item md={12} sm={12} xs={12}>
                          <Grid component="label" container alignItems="center" spacing={1}>
                            <Grid item>
                              <Switch
                                  checked={formState.authorised}
                                  color="secondary"
                                  edge="start"
                                  name="authorised"
                                  onChange={handleFieldChange}
                                  value={formState.authorised}
                                  disabled={!canEdit || !isAdmin}
                              />
                            </Grid>
                            <Grid item><Typography variant="h5">Authorized?</Typography></Grid>
                          </Grid>
                        </Grid>
                    )}

                    {isAdmin && (
                      <Grid item md={12} sm={12} xs={12}>
                        <Grid component="label" container alignItems="center" spacing={1}>
                          <Grid item>
                            <Switch
                                checked={formState.cancelled}
                                color="secondary"
                                edge="start"
                                name="cancelled"
                                onChange={handleFieldChange}
                                value={formState.cancelled}
                                disabled={!canEdit || !isAdmin}
                            />
                          </Grid>
                          <Grid item><Typography variant="h5">Cancelled?</Typography></Grid>
                        </Grid>
                      </Grid>
                    )}

                    {isAdmin && (
                    <Grid item md={12} sm={12} xs={12}>
                      <Grid component="label" container alignItems="center" spacing={1}>
                        <Grid item>
                          <Switch
                              checked={formState.disabled}
                              color="secondary"
                              edge="start"
                              name="disabled"
                              onChange={handleFieldChange}
                              value={formState.disabled}
                              disabled={!canEdit || !isAdmin}
                          />
                        </Grid>
                        <Grid item><Typography variant="h5">Disabled?</Typography></Grid>
                      </Grid>
                    </Grid>
                      )}

                    {isAdmin && (
                    <Grid item  sm={12} xs={12}>
                      <Button className={classes.saveButton} onClick={onSaveClick} variant="contained"
                              disabled={!errors.isValid || !canEdit}>
                        Save
                      </Button>
                      <Can permission="groups.delete">
                        <Button onClick={handleOpenDeleteModal} className={classes.deleteButton} variant="contained"
                                disabled={isNewGroupMember}>
                          Delete
                        </Button>
                      </Can>
                      <Button className={classes.cloneButton} onClick={onCloneClick} variant="contained"
                              disabled={isNewGroupMember || !errors.isValid}>
                        Clone
                      </Button>
                    </Grid>
                    )}

                  </Grid>
                </CardContent>
              </Card>
            </LoadingOverlay>
        )}

        {tab === 'options' && (
            <RoomPartyMemberOptionsEdit roomPartyMembers={[groupMember.roomMember!]} groupId={groupMember.group_id!} groupRef={groupMember.group!.booking_form_url} isAdmin={isAdmin} canEdit={canEdit}/>
        )}

        {tab === 'adjustments' && (
            <GroupMemberAdjustmentsListContent groupMember={groupMember} isAdmin={isAdmin} canEdit={canEdit}/>
        )}

        {tab === 'payments' && (
            <GroupMemberPaymentsList groupMember={groupMember} />
        )}

        {!isNewGroupMember && tab === 'documents' && (
            <DocumentDownloadListContent
                groupId={props.groupMember.group_id!}
                groupMemberId={props.groupMember.id}
                tourRole={props.groupMember.tour_role}
                isAdmin={isAdmin}
            />
        )}

        {tab === 'notes' && (
            <div>
              <Button
                  color="primary"
                  onClick={() => setOpenModal(true)}
                  size="small"
                  variant="outlined"
              >
                Add Note
              </Button>
              <NotesList type={"group_member"} type_id={groupMember.id} />
              {openModal && (<AddNote onClose={() => setOpenModal(false)} type={WcvType.GROUP_MEMBER}
                                      type_id={groupMember.id}/>)}
            </div>
        )}

        {tab === 'logs' && <LogListContent type={WcvType.GROUP_MEMBER} type_id={groupMember.id}/>}

        {openDeleteModal && (
            <ConfirmDelete onClose={handleCloseDeleteModal} onDeleteClick={handleDelete} open={true}/>
        )}

        {openAuthoriseAllModal && (
            <ConfirmModal
                onClose={handleCloseAuthoriseAllModal}
                onConfirmClick={() => {
                  setAuthorizeAllInGroup(true);
                  handleCloseAuthoriseAllModal();
                }}
                open={true}
                title="Authorize All"
                message="Would you like to authorize all group members in this billing party on saving?"
                submitIsDelete
            />
        )}

        {openCancelAllModal && (
            <ConfirmModal
                onClose={handleCloseCancelAllModal}
                onConfirmClick={() => {
                  setCancelAllInGroup(true);
                  handleCloseCancelAllModal();
                }}
                open={true}
                title="Cancel All"
                message="Would you like to cancel all group members in this billing party on saving?"
                submitIsDelete
            />
        )}
        {openUnavailableOptionsModal && (
            <ConfirmModal
                onClose={handleCloseUnavailableOptionsModal}
                onConfirmClick={() => {
                    setTab('options')
                    handleCloseUnavailableOptionsModal();
                }}
                open={true}
                title="Options were not able to be reinstated based on the original selections"
                message="Some of the original Room Party Member options are no longer available and could not be restored on the Member"
            />
        )}
      </React.Fragment>
  );
};

export const MyGroupMemberDetails = () => {
  const {history, match}: RouteComponentProps<{ json: string }> = useReactRouter();
  const classes = useStyles();
  const {json} = match.params;
  const jsonObj = JSON.parse(atob(json));
  const groupMemberData = getGroupMemberInMyGroup(Number(jsonObj.id));
  const {enqueueSnackbar} = useSnackbar();
  const title = 'Group Member Details';

  const groupMember = groupMemberData.data && groupMemberData.data.groupMemberInMyGroup;

  //Check if we can edit the form
  const isAdmin = checkIsAdmin();
  const checkLevel = checkEditLevel();
  const canEdit = groupMember && groupMember.group ? checkLevel(groupMember.group.id, groupMember.group.editing_level!) : false;

  useEffect(() => {
    if (groupMemberData.error) {
      enqueueSnackbar(`There was an error loading Group Member`, {variant: 'error'});
      history.push('/mygroups');
    }
  }, [groupMemberData.error]);

  return (
      <Page className={classes.root} title={title}>
        <PageHeader section="groups" title={title}/>
        <LoadingOverlay loading={groupMemberData.loading}>
          {groupMember && (
              <GroupMemberDetailsContent groupMember={groupMember} isAdmin={isAdmin} canEdit={canEdit}
                                         groupRef={groupMember.group!.booking_form_url}/>)}
        </LoadingOverlay>
      </Page>
  );
};

const GroupMemberDetails = () => {
    const {history, match}: RouteComponentProps<{ id: string, group_id?: string }> = useReactRouter();
    const classes = useStyles();
    const {id, group_id} = match.params;
    const newGroupMember = id === 'new';
    const groupMemberData = newGroupMember ? {
        loading: false,
        data: {groupMember: getBlankGroupMember(group_id ? Number(group_id) : -1)},
        error: undefined
    } : getGroupMember(Number(id));
    const {enqueueSnackbar} = useSnackbar();
    const title = 'Group Member Details';

    const groupName = groupMemberData && groupMemberData.data && groupMemberData.data.groupMember && groupMemberData.data.groupMember.group ? groupMemberData.data.groupMember.group.name : '';

    useEffect(() => {
        if (groupMemberData.error) {
            enqueueSnackbar(`There was an error loading Group Member ${id}`, {variant: 'error'});
            history.push('/groupmembers');
        }
    }, [groupMemberData.error]);

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section={`groups ${groupName !== undefined ? groupName : ''}`} title={title}/>
            <LoadingOverlay loading={groupMemberData.loading}>
                {groupMemberData.data && groupMemberData.data.groupMember && (
                    <GroupMemberDetailsContent groupMember={groupMemberData.data.groupMember} isAdmin={true}
                                               canEdit={true}/>)}
            </LoadingOverlay>
        </Page>
    );
};

export default GroupMemberDetails;
